/**
 * Homework scene renderer
 */

import type { SceneData, SceneConfig } from '../types'

export interface HomeworkRendererContext {
  container: HTMLDivElement
  data: SceneData
  config: SceneConfig
  onOverlaySetup?: () => void
}

/**
 * Render homework scene
 * Homework scenes don't render any background image
 * They just add a button that opens the homework overlay
 */
export function renderHomework(context: HomeworkRendererContext): HTMLElement {
  const { container, data, config, onOverlaySetup } = context

  // Apply margin from config (1 unit = 1vh) with svh/vh fallback
  const marginVh = config.homework.margin
  // Set both svh and vh - browsers that support svh will use it, others will use vh
  container.style.paddingTop = `${marginVh}vh`
  container.style.paddingTop = `${marginVh}svh`
  container.style.paddingBottom = `${marginVh}vh`
  container.style.paddingBottom = `${marginVh}svh`

  // Static styles are in CSS (.homework-scene class)

  // Setup homework overlay after container is added to DOM
  if (onOverlaySetup) {
    requestAnimationFrame(() => {
      onOverlaySetup()
    })
  }

  return container
}
